import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useFormContext } from 'react-hook-form';

import { defaultValues } from './model';
import type { JobPositionFormSchema } from './schemas';
import { jobPositionFormSchema } from './schemas';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(jobPositionFormSchema),
    defaultValues,
  });
}

export const useJobPositionFormContext = () => useFormContext<JobPositionFormSchema>();
